import React from 'react';
import { LuChartPie, LuChevronDown, LuList, LuPlus } from 'react-icons/lu';

import { Button } from '@/components/ui/button';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { PageTitle, PageTitleRow } from '@/components/ui/page-layout';

import { LibraryFilterKey } from './LibraryFilterBar';

interface LibraryTitleBarProps {
    filter: LibraryFilterKey;
    modelCount: number;
    strategyCount: number;
    onNewModel: () => void;
    onNewStrategy: () => void;
}

export const LibraryTitleBar: React.FC<LibraryTitleBarProps> = ({
    filter,
    modelCount,
    strategyCount,
    onNewModel,
    onNewStrategy,
}) => (
    <PageTitleRow
        actions={
            filter === 'my-strategies' ? (
                <Button
                    variant="default"
                    className="ml-auto flex items-center gap-1.5 font-medium"
                    onClick={onNewStrategy}
                >
                    <LuPlus /> New Strategy
                </Button>
            ) : filter === 'my-models' ? (
                <Button
                    variant="default"
                    className="ml-auto flex items-center gap-1.5 font-medium"
                    onClick={onNewModel}
                >
                    <LuPlus /> New Model
                </Button>
            ) : (
                <DropdownMenu>
                    <DropdownMenuTrigger asChild>
                        <Button variant="default" className="ml-auto flex items-center gap-1.5 font-medium">
                            <LuPlus /> Create <LuChevronDown className="h-3.5 w-3.5 opacity-70" />
                        </Button>
                    </DropdownMenuTrigger>
                    <DropdownMenuContent align="end" className="tracking-[-0.02em]">
                        <DropdownMenuItem onClick={onNewStrategy} className="flex items-center gap-2">
                            <LuList className="text-seafoam-600 h-4 w-4" /> New Strategy
                        </DropdownMenuItem>
                        <DropdownMenuItem onClick={onNewModel} className="flex items-center gap-2">
                            <LuChartPie className="text-gold-600 h-4 w-4" /> New Model
                        </DropdownMenuItem>
                    </DropdownMenuContent>
                </DropdownMenu>
            )
        }
    >
        <div className="flex flex-col">
            <PageTitle>Model Library</PageTitle>
            <p className="text-cocoa-600 -mt-1 text-sm font-thin tabular-nums">
                {modelCount + strategyCount} objects · {modelCount} Models · {strategyCount} Strategies
            </p>
        </div>
    </PageTitleRow>
);
